function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "sx-search-lg",
  clipPath: "url(#clip0_12210_129143)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.68733 1.75002C4.40814 1.75002 1.74984 4.40832 1.74984 7.68751C1.74984 10.9667 4.40814 13.625 7.68733 13.625C9.28103 13.625 10.7281 12.9971 11.7946 11.9752C11.8192 11.9411 11.8469 11.9084 11.8776 11.8777C11.9083 11.847 11.941 11.8193 11.9751 11.7947C12.997 10.7282 13.6248 9.28118 13.6248 7.68751C13.6248 4.40832 10.9665 1.75002 7.68733 1.75002ZM13.5358 12.4163C14.5817 11.1245 15.2082 9.47915 15.2082 7.68751C15.2082 3.53387 11.841 0.166687 7.68733 0.166687C3.53369 0.166687 0.166504 3.53387 0.166504 7.68751C0.166504 11.8411 3.53369 15.2083 7.68733 15.2083C9.479 15.2083 11.1243 14.5818 12.4162 13.5359L14.6484 15.7681C14.9575 16.0773 15.4588 16.0773 15.7679 15.7681C16.0771 15.459 16.0771 14.9577 15.768 14.6486L13.5358 12.4163Z",
  fill: "#98A2B3"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_12210_129143"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

function SvgSxSearchLg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSxSearchLg);
export default __webpack_public_path__ + "static/media/sx-search-lg.8bf4ca3b.svg";
export { ForwardRef as ReactComponent };